import {Loader2} from "lucide-react";
import {useNavigate} from "react-router-dom";

import {Button} from "@/components/ui/button";

export type ClaimVerifyResultProps =
  | {variant: "loading"}
  | {variant: "expired"; message: string}
  | {variant: "invalid"; message: string}
  | {variant: "unavailable"; message: string};

export default function ClaimVerifyResult(props: ClaimVerifyResultProps) {
  const navigate = useNavigate();

  if (props.variant === "loading") {
    return (
      <div className="flex flex-col items-center gap-4 py-4 text-center">
        <Loader2 className="size-8 animate-spin text-muted-foreground" />
        <p className="text-muted-foreground">Verifying your account...</p>
      </div>
    );
  }

  if (props.variant === "unavailable") {
    return (
      <div className="flex flex-col gap-4 text-center">
        <p className="text-foreground">{props.message}</p>
        <p className="text-sm text-muted-foreground">
          Please contact your property management office for assistance.
        </p>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4 text-center">
      <p className="text-foreground">{props.message}</p>
      <p className="text-sm text-muted-foreground">
        If you received a new welcome letter, use the latest claim code to start again.
      </p>
      <Button className="w-full" onClick={() => navigate("/resident-claim")}>
        Restart claim
      </Button>
    </div>
  );
}
